<script setup lang="ts">
import {Sidebar, SidebarContent, SidebarFooter, SidebarRail} from '@/components/ui/sidebar'
import SidebarNav from './SidebarNav.vue'
import NavUser from './NavUser.vue'
</script>

<template>
  <Sidebar collapsible="icon">
    <SidebarContent>
      <SidebarNav />
    </SidebarContent>
    <SidebarFooter>
      <NavUser />
    </SidebarFooter>
    <SidebarRail />
  </Sidebar>
</template>
